'use client'

import { useRouter } from 'next/navigation'
import { InternalRefreshRouteOnSave } from './InternalRefreshRouteOnSave'

export const RefreshRouteOnSave = () => {
  const router = useRouter()
  const resolvedServerURL = process.env.NEXT_PUBLIC_NEXT_BASE_URL
  if (!resolvedServerURL) {
    return null
  }

  return (
    <InternalRefreshRouteOnSave
      refresh={() => router.refresh()}
      serverURL={resolvedServerURL}
    />
  )
}
